<template>
  <div class="content">
    <Form :model="formData" ref="form" :label-width="150">
      <!-- <FormItem label="是否录音">
        <i-switch v-model="formData.is_record" :disabled="!isEdit"/>
      </FormItem> -->
      <FormItem label="是否启用人机协同">
        <i-switch v-model="formData.is_hmc" :disabled="!isEdit"/>
      </FormItem>
      <FormItem label="呼叫超时时长">
        <InputNumber v-model="formData.call_timeout" :min="0" :disabled="!isEdit" style="width: 200px"/><span style="margin-left: 5px">s</span>
      </FormItem>
      <FormItem label="最大通话时长">
        <InputNumber v-model="formData.max_talk_time" :min="0" :disabled="!isEdit" style="width: 200px"/><span style="margin-left: 5px">s</span>
      </FormItem>
      <FormItem label="等待响应超时时长">
        <InputNumber v-model="formData.input_timeout" :min="0" :disabled="!isEdit" style="width: 200px"/><span style="margin-left: 5px">ms</span>
      </FormItem>
      <FormItem label="最大连续超时次数">
        <InputNumber v-model="formData.max_timeouts" :min="0" :disabled="!isEdit" style="width: 200px"/>
      </FormItem>
      <FormItem label="拦截语音助手">
        <i-switch v-model="formData.block_robot" :disabled="!isEdit"/>
      </FormItem>
      <FormItem
        prop="freq_limit.interval"
        :rules="freqLimitIntervalRules">
        <div slot="label">
          <span>呼频限制</span>
          <Tooltip content="0小时表示不限制" placement="top">
            <Icon type="ios-help-circle-outline" />
          </Tooltip>
        </div>
        <AutoComplete
          v-model="formData.freq_limit.interval"
          :data="[24, 48, 72, 96, 120]"
          :disabled="!isEdit"
          style="width:200px">
        </AutoComplete>
        <span style="margin-left: 5px">小时</span>
        <InputNumber style="width: 200px; margin-left: 5px" v-model="formData.freq_limit.count" :min="1" :disabled="!isEdit"/>
        <span style="margin-left: 5px">次</span>
      </FormItem>
      <FormItem label="最小通话时长">
        <InputNumber v-model="formData.freq_limit.minDuration" :min="0" :disabled="!isEdit" style="width: 200px"/>
      </FormItem>
      <FormItem label="录音时机">
        <Select v-model="formData.recording_at" style="width: 420px" :disabled="!isEdit">
          <Option value="none">不录音</Option>
          <!-- <Option value="ring">振铃时</Option> -->
          <Option value="answer">接通时</Option>
          <Option value="takeover">接管时</Option>
        </Select>
      </FormItem>
      <FormItem label="延迟录音时长">
        <InputNumber v-model="formData.recording_offset" :min="0" :disabled="!isEdit" style="width: 200px"/><span style="margin-left: 5px">s</span>
      </FormItem>
      <FormItem label="入声音量">
        <InputNumber v-model="formData.inbound_audio_level" :min="-4" :max="4" :disabled="!isEdit" style="width: 200px"/>
      </FormItem>
      <FormItem label="出声音量">
        <InputNumber v-model="formData.outbound_audio_level" :min="-4" :max="4" :disabled="!isEdit" style="width: 200px"/>
      </FormItem>
      <FormItem label="系统意图阀值">
        <InputNumber v-model="formData.sys_intent_threshold" :min="0" :disabled="!isEdit" style="width: 200px"/>
      </FormItem>
      <FormItem label="是否启用实时降噪">
        <i-switch v-model="formData.enable_real_time_denoise" :disabled="!isEdit"/>
      </FormItem>
      <FormItem label="语气词过滤">
        <i-switch v-model="formData.echo_word.enable" :disabled="!isEdit"/>
      </FormItem>
      <FormItem label="添加语气词">
        <div v-if="isEdit">
          <Input v-model="newEchoWord" @on-enter="addEchoWord" placeholder="多个语气词用分号（;）分割，按回车确认" style="margin-bottom: 10px" />
          <keyword-hint :keywords="formData.echo_word.words" @change="updateEchoWords" closable/>
        </div>
        <div v-else>
          <keyword-hint :keywords="formData.echo_word.words" closable/>
        </div>
      </FormItem>
      <FormItem label="超时播放语音">
        <form-item-voice 
          :disabled="!isEdit"
          :voice="formData.timeout_voices[0]"
          @change="formData.timeout_voices = [$event]"
        />
      </FormItem>
      <FormItem>
        <Button type="primary" v-show="!isEdit" @click="openEdit">编辑</Button>
        <Button type="primary" v-show="isEdit" @click="save">保存</Button>
        <Button style="margin-left: 8px" v-show="isEdit" @click="cancel">取消</Button>
      </FormItem>
    </Form>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import FormItemVoice from '../../../components/FormItemVoice.vue'
import KeywordHint from '../../../components/KeywordHint.vue'
import { addNodeId } from '@/utils/nodeIdPool';

export default {
  components: { FormItemVoice, KeywordHint },
  data() {
    return {
      isEdit: false,
      newEchoWord: '',
      formData: {
        is_hmc: false, // 是否启用人机协同
        call_timeout: 0,   //呼叫超时时长 单位秒
        max_talk_time: 0, //最大通话时长 单位秒
        input_timeout: 0, //等待响应超时时长 单位毫秒
        max_timeouts: 0, // 最大连续超时次数，超过则挂机
        block_robot: false, // 拦截语音助手
        freq_limit: {
          interval: 0,
          count: 1,
          minDuration: 0,
        },
        timeout_voices: [{ voice: '', text: '', id: addNodeId('V') }],
        recording_at: 'answer',
        recording_offset: 0,
        sys_intent_threshold: 0,
        inbound_audio_level: 0,
        outbound_audio_level: 0,
        enable_real_time_denoise: false,
        echo_word: {
          enable: false,
          words: [],
        },
      },
      freqLimitIntervalRules: {
        type: 'number',
        asyncValidator: (rule, value) => {
          return new Promise((resolve, reject) => {
            if (~~value < 0) {
              reject('不能小于0小时');  // reject with error message
            } else if (~~value > 720 ) {
              reject('不能大于720小时');  // reject with error message
            } else {
              resolve();
            }
          });
        },
      }
    }
  },
	computed: {
    ...mapState('setting', ['general', 'echo_word']),
	},
  watch: {
    general: {
      immediate: true,
      handler(val) {
        this.resetForm()
      }
    },
    echo_word: {
      immediate: true,
      handler(val) {
        this.resetForm()
      }
    }
  },
  methods: {
    ...mapActions('setting', ['updateGeneralAndEchoWord']),
    openEdit() {
      this.isEdit = true;
    },
    cancel() {
      this.isEdit = false;
      this.resetForm();
    },
    resetForm() {
      let timeout_voices = this.general.timeout_voices;
      if (!timeout_voices || timeout_voices.length === 0) {
        timeout_voices = [{ voice: '', text: '', id: addNodeId('V') }]
      }
      const freq_limit = this.general.freq_limit || {
        interval: 0,
        count: 1,
        minDuration: 0,
      }
      const echo_word = this.echo_word || {
        enable: false,
        words: [],
      }
      this.formData = {
        is_hmc: false,   //是否启用人机协同
        call_timeout: 0,   //呼叫超时时长 单位秒
        max_talk_time: 0, //最大通话时长 单位秒
        input_timeout: 0, //等待响应超时时长 单位毫秒
        max_timeouts: 0, // 最大连续超时次数，超过则挂机
        block_robot: false, // 拦截语音助手
        recording_at: 'answer',
        recording_offset: 0,
        sys_intent_threshold: 0,
        inbound_audio_level: 0,
        outbound_audio_level: 0,
        enable_real_time_denoise: false,
        ...this.general,
        freq_limit,
        timeout_voices,
        echo_word,
      }
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.formData.timeout_voices = this.formData.timeout_voices.filter(item => item.text || item.voice)
          this.formData.freq_limit = {
            interval: ~~this.formData.freq_limit.interval,
            count: ~~this.formData.freq_limit.count,
            minDuration: ~~this.formData.freq_limit.minDuration,
          }
          this.formData.is_record = true;

          // 从 formData 中移除 echo_word，只保存 general 相关的数据
          const generalData = { ...this.formData };
          delete generalData.echo_word;
          this.updateGeneralAndEchoWord({
            general: generalData,
            echoWord: this.formData.echo_word,
          });

          this.isEdit = false;
        }
      })
    },
    addEchoWord() {
      if (!this.newEchoWord.trim()) return;

      // 按分号分割多个语气词
      const words = this.newEchoWord.split(';').map(w => w.trim()).filter(w => w);

      // 合并到现有列表中，去重
      const currentWords = this.formData.echo_word.words || [];
      const newWords = [...new Set([...currentWords, ...words])];

      this.formData.echo_word.words = newWords;
      this.newEchoWord = '';
    },
    updateEchoWords(words) {
      this.formData.echo_word.words = words;
    },
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-top: 15px;
}
</style>
